var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5129 0.245526C27.6676 0.245526 29.3998 1.92389 29.3998 4.01161V24.0291C29.3998 26.1169 27.6676 27.7952 25.5129 27.7952H4.85336C2.69868 27.7952 0.966492 26.1169 0.966492 24.0291V3.97067C0.966492 1.88295 2.69868 0.20459 4.85336 0.20459H25.5129V0.245526ZM25.7664 2.45605C26.4846 2.45605 27.0761 3.02915 27.0761 3.72506V24.2338C27.0761 24.9297 26.4846 25.5028 25.7664 25.5028H19.1334V16.5379H21.8796C22.4288 16.5379 22.9358 16.1695 23.147 15.6783L23.7385 13.959C23.9497 13.3449 23.485 12.69 22.809 12.69H19.1756V10.111C19.1756 9.45605 19.8516 8.84202 20.4853 8.84202H23.147C23.8652 8.84202 24.4567 8.26892 24.4567 7.57301V6.71336C24.4567 6.304 24.2032 5.93558 23.7807 5.81278C22.0485 5.36248 20.4853 5.36248 20.4853 5.36248C17.19 5.36248 15.2043 7.57301 15.2043 9.49699V12.69H12.5426C11.8244 12.69 11.2329 13.2631 11.2329 13.959V15.228C11.2329 15.9239 11.8244 16.497 12.5426 16.497H15.2043V25.4619H4.59987C3.88164 25.4619 3.29017 24.8888 3.29017 24.1929V3.72506C3.29017 3.02915 3.88164 2.45605 4.59987 2.45605H25.7664Z",
    fill: "#446073"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.2c5da205eae2507e14e7fbd044a0dd4b.svg";
export { ForwardRef as ReactComponent };